import { axios } from "./index";

const base = "facilities";

class FacilitiesAPI {
  // GET /facilities/list-facilities
  static ListFacilities = () => {
    return axios.get(`${base}/list-facilities`);
  };

  // POST /facilities/create-facilities
  static CreateFacility = (data) => {
    return axios.post(`${base}/create-facilities`, data);
  };
}

export default FacilitiesAPI;
